import { NavLink, useLocation } from "react-router-dom";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import { ucFirstAllWords } from "../utils/helper";

function getBreadcrumbs(path = "") {
  const parts = path.split("/").filter((el) => Boolean(el));
  return parts.map((part, index) => {
    const to = "/" + parts.slice(0, index + 1).join("/");
    const page = part.includes("-")
      ? part
      : part.charAt(0).toUpperCase() + part.slice(1);
    return { to, page };
  });
}

const SiteBreadcrumb = (props: any) => {
  const location = useLocation();
  const breadcrumbs = getBreadcrumbs(location.pathname);
  const crumbs = breadcrumbs
    .filter(({ page }) => page != "Dashboard")
    .map(({ to, page }) => {
      const pageName = ucFirstAllWords(page.replace("-", " "));
      return { name: pageName, to };
    });

  const homepage = { name: "Home", to: "/dashboard" };
  const items = [homepage, ...crumbs];

  return (
    <Breadcrumbs
      separator="›"
      sx={{
        mb: { xs: 1.5, sm: 2 },
        px: { xs: 1, sm: 0 },
        "& .MuiBreadcrumbs-ol": {
          flexWrap: "wrap",
          rowGap: 0.5,
        },
      }}
    >
      {items.map((it, idx) => {
        const last = idx === items.length - 1;
        return last ? (
          <Typography
            key={idx}
            sx={{
              fontWeight: "500",
              letterSpacing: 0.5,
              fontSize: { xs: "0.7rem", sm: "0.875rem" },
              wordBreak: "break-word",
            }}
          >
            {it.name}
          </Typography>
        ) : (
          <Link
            key={idx}
            underline="hover"
            component={NavLink}
            to={it.to}
            sx={{
              letterSpacing: 0.5,
              fontSize: { xs: "0.7rem", sm: "0.875rem" },
              wordBreak: "break-word",
            }}
          >
            {it.name}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
};

export default SiteBreadcrumb;
